import api from './api';

const TOKEN_KEY = 'auth_token';

export const authService = {
  // Login user
  async login(username, password) {
    const response = await api.post('/auth/login', { username, password });
    return response.data.data;
  },

  // Register user
  async register(username, password) {
    const response = await api.post('/auth/register', { username, password });
    return response.data.data;
  },

  // Request password reset
  async requestPasswordReset(username) {
    const response = await api.post('/auth/reset-password', { username });
    return response.data.data;
  },

  // Confirm password reset
  async confirmPasswordReset(username, resetToken, newPassword) {
    const response = await api.post('/auth/reset-password/confirm', {
      username,
      reset_token: resetToken,
      new_password: newPassword
    });
    return response.data.data;
  },

  // Logout (client-side only)
  // NOTE: Prefer using useAuthStore().logout() instead
  logout() {
    localStorage.removeItem(TOKEN_KEY);
  },

  // Check if user is authenticated
  // NOTE: Prefer using useAuthStore().isAuthenticated instead
  isAuthenticated() {
    return !!localStorage.getItem(TOKEN_KEY);
  },

  // Get stored token
  // NOTE: Prefer using useAuthStore().getToken instead
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  // Set token
  // NOTE: Prefer using useAuthStore().login() instead
  setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
};